import { FC } from "react";
import { Tooltip } from "antd";
import { ViewModeSwitchContainer } from "./styled";

export interface ViewModeSwitchProps {
  viewMode: "view" | "record";
  onViewModeChange: (mode: "view" | "record") => void;
  fontSize?: number;
  height?: number;
}

const ViewModeSwitch: FC<ViewModeSwitchProps> = ({
  viewMode,
  onViewModeChange,
  fontSize = 14,
  height = 32,
}) => {
  return (
    <ViewModeSwitchContainer>
      <div className="view-mode-switch" style={{ height }}>
        <div
          className={`view-mode-item ${
            viewMode === "view" ? "view-mode-item-active" : ""
          }`}
          style={{ fontSize: fontSize - 1 }}
          onClick={() => onViewModeChange("view")}
        >
          閲覧
        </div>
        <Tooltip title="開発中" color="#6BC77A">
          <div
            className="view-mode-item view-mode-item-disabled"
            style={{ fontSize: fontSize - 1 }}
          >
            レコード編集
          </div>
        </Tooltip>
        <Tooltip title="開発中" color="#6BC77A">
          <div
            className="view-mode-item view-mode-item-disabled"
            style={{ fontSize: fontSize - 1 }}
          >
            レイアウト編集
          </div>
        </Tooltip>
      </div>
    </ViewModeSwitchContainer>
  );
};

export default ViewModeSwitch;
